"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateGraphOptions = exports.generateAggregatedData = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const generateGraphOptions = function (props) {
  const {
    filter,
    generateOptions,
    t,
    fileName
  } = props;
  if (props.data) {
    const data = new Promise((resolve, _) => resolve(props.data));
    return data.then(result => generateOptions(result, filter, t, fileName));
  }
  const data = generateAggregatedData(props);
  return data.then(arr => arr.length == 0 ? new Promise((resolve, _) => resolve({})) : data.then(result => generateOptions(result, filter, t, fileName)));
};
exports.generateGraphOptions = generateGraphOptions;
const generateAggregatedData = function (props, isSaveEnabled = true) {
  const {
    filter,
    name,
    dataAggregator,
    dataLoader
  } = props;
  if (typeof dataLoader == 'undefined') {
    return new Promise((resolve, _) => resolve([props.id]));
  } else {
    let rawData, names;
    switch (filter.mode) {
      case 'simple':
        rawData = getRawData(name, props);
        return rawData.then(result => aggregateData(result, filter, dataAggregator, isSaveEnabled));
      case 'compare':
        names = ExtractNamesFromKeyNameInCompareMode(name);
        rawData = names.map((name, index) => getRawData(name, props, index));
        return Promise.all(rawData).then(result => aggregateData(result, filter, dataAggregator, isSaveEnabled));
    }
  }
};
exports.generateAggregatedData = generateAggregatedData;
const getRawData = function (name, props, i = 0) {
  return _ServiceLocator.default.collectionManager.has(name) ? new Promise((resolve, _) => resolve(_ServiceLocator.default.collectionManager.get(name).features)) : loadDataByFilter(props, i);
};
const loadDataByFilter = function (props, i) {
  const {
    filter,
    dataLoader,
    name
  } = props;
  const collection = new dataLoader([], {}, _ServiceLocator.default.eventManager);
  let tempFilter = _objectSpread({}, filter);
  tempFilter.period = filter.period[i];
  return load(collection, name, tempFilter);
};
const load = function (collection, name, filter) {
  return collection.loadFromServerByFilter(_ServiceLocator.default.socketEventManager, _ServiceLocator.default.collectionManager, filter).then(function (response) {
    _ServiceLocator.default.collectionManager.add(name, collection);
    return collection;
  }).then(result => {
    return result.features.map(x => x.attributes);
  });
};
const aggregateData = function (response, filter, dataAggregator, isSaveEnabled) {
  if (response.length > 0) {
    return dataAggregator(response, filter, isSaveEnabled);
  } else {
    return [];
  }
};
const ExtractNamesFromKeyNameInCompareMode = function (keyName) {
  const object = JSON.parse(keyName);
  const {
    segments,
    period
  } = object;
  const names = [];
  period.start.forEach(function (value, i) {
    const name = {
      'segments': segments,
      'period': {
        'start': period.start[i],
        'end': period.end[i]
      }
    };
    names.push(JSON.stringify(name));
  });
  return names;
};